import React, { useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'

import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import CloseIcon from '@material-ui/icons/Close'

import Button from './Button'

const styles = theme => ({
  iconClose: {
    position:'absolute', 
    right: '16px', 
    top: '16px', 
    cursor:'pointer'
  }
})

const DialogBox = ({ theme, classes, children, ...props }) => {

  const { title, actionButtons, onClose, show } = props

  return (
    <Dialog 
      open={ show } 
      onClose={ onClose } 
      aria-labelledby="form-dialog-title"
      fullWidth
      >
        <DialogTitle id="form-dialog-title">{ title || ''}</DialogTitle>
        <DialogContent>
          { children }
          { onClose &&
            <Box className={classes.iconClose}>
                <CloseIcon 
                    onClick={onClose}
                />
            </Box>
          }
        </DialogContent>
        <DialogActions>
          { actionButtons }
        </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles, { withTheme: true })(
    (DialogBox)
)
